var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomContainer', {
    staticClass: "patternmaker-sticker-tabs",
    attrs: {
      "elementType": "section"
    }
  }, [_vm.enableSwiper ? _c('CustomContainer', {
    staticClass: "patternmaker-sticker-tabs-content",
    attrs: {
      "elementType": "div"
    }
  }, [_c('swiper', {
    ref: "tabsCarousel",
    class: ['patternmaker-sticker-tabs-content-swiper', {
      'patternmaker-sticker-tabs-content-swiper--no-loop': !_vm.tabsSwiper.loop
    }],
    attrs: {
      "options": _vm.tabsSwiper
    },
    on: {
      "click": _vm.onTabClicked
    }
  }, _vm._l(_vm.stickerGroupsArray, function (group, index) {
    return _c('swiper-slide', {
      key: group.name,
      class: ['patternmaker-sticker-tabs-content-tab', "patternmaker-sticker-tabs-content-tab--".concat(index), {
        active: group.name === _vm.currentStickerGroup
      }],
      attrs: {
        "data-group-name": group.name
      }
    }, [_vm._v("\n          " + _vm._s(group.display_name) + "\n          "), _c('span', {
      class: ['patternmaker-sticker-tabs-content-tab-active-marker', {
        'patternmaker-sticker-tabs-content-tab-active-marker--active': group.name === _vm.currentStickerGroup
      }]
    }, [_vm._v("\n            " + _vm._s(group.display_name) + "\n          ")])]);
  }), 1), _c('CustomContainer', {
    attrs: {
      "customClass": ['patternmaker-sticker-tabs-content-nav-wrapper', {
        'hide': !_vm.enableCarouselNavigation
      }],
      "elementType": "div"
    }
  }, [_c('button', {
    staticClass: "patternmaker-sticker-tabs-content-nav-button-previous",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left-indicator-open",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  })]), _c('button', {
    staticClass: "patternmaker-sticker-tabs-content-nav-button-next",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right-indicator-open patternMaker-arrow",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })])])], 1) : _c('base-spinner', {
    attrs: {
      "size": "50",
      "position": "inherit"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }